import {Routes} from '@angular/router';
import {LayoutComponent} from "./layout/layout.component";
import {AuthGuard} from "./guards/auth.guard";
import {NoAuthGuard} from "./guards/no.auth.guard";
import {BlogComponent} from "./blog/blog.component";
import {BlogListComponent} from "./blog/blog-list/blog-list.component";
import {BlogDetailsComponent} from "./blog/blog-details/blog-details.component";
import {DspTransactionsComponent} from "./dsp-transactions/dsp-transactions.component";
import {UpcomingSchemeDeliveryComponent} from "./upcoming-scheme-delivery/upcoming-scheme-delivery.component";
import {RewardsLandingPageComponent} from "./rewards-landing-page/rewards-landing-page.component";

export const routes: Routes = [
  {
    path: 'offers/:deliveryId',
    loadComponent: () => import('./rewards-landing-page/rewards-landing-page.component').then(m => m.RewardsLandingPageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: '', component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
      },
      {
        path: "login",
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
        canActivate: [NoAuthGuard]
      },
      {
        path: "products",
        loadComponent: () => import('./schemes/scheme/scheme.component').then(m => m.SchemeComponent)
      },
      {
        path: "deliveries",
        loadComponent: () => import('./users/user-scheme-deliveries/user-scheme-deliveries.component').then(m => m.UserSchemeDeliveriesComponent),
        canActivate: [AuthGuard]
      },
      {
        path: "Products",
        redirectTo: "products",
        pathMatch: "full"
      },
      {
        path: "products/:id",
        loadComponent: () => import('./schemes/new-scheme/new-scheme.component').then(m => m.NewSchemeComponent)
      },
      {
        path: "products/:id/estimateCost",
        loadComponent: () => import('./schemes/calculation/calculation.component').then(m => m.CalculationComponent)
      },
      // {
      //   path: "about-us",
      //   loadComponent: () => import('./about-us/about-us.component').then(m => m.AboutUsComponent)
      // },
      {
        path: "our-company",
        loadComponent: () => import('./our-company/our-company.component').then(m => m.OurCompanyComponent)
      },
      {
        path: "faqs",
        loadComponent: () => import('./faqs/faqs.component').then(m => m.FaqsComponent)
      },
      {
        path: "contact-us",
        loadComponent: () => import('./contact-us/contact-us.component').then(m => m.ContactUsComponent)
      },
      {
        path: "certificate-guide",
        loadComponent: () => import('./certificate-guide/certificate-guide.component').then(m => m.CertificateGuideComponent)
      },
      {
        path: 'payment-warning',
        loadComponent: () => import('./payment-warning/payment-warning.component').then(m => m.PaymentWarningComponent)
      },
      {
        path: "shipping-policy",
        loadComponent: () => import('./shipping-policy/shipping-policy.component').then(m => m.ShippingPolicyComponent)
      },
      {
        path: "cookies-policy",
        loadComponent: () => import('./cookies-policy/cookies-policy.component').then(m => m.CookiesPolicyComponent)
      },
      {
        path: "privacy-policy",
        loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: "cancellation-policy",
        loadComponent: () => import('./cancellation-policy/cancellation-policy.component').then(m => m.CancellationPolicyComponent)
      },
      {
        path: "fraud-disclaimer",
        loadComponent: () => import('./fraud-disclaimer-policy/fraud-disclaimer-policy.component').then(m => m.FraudDisclaimerPolicyComponent)
      },
      {
        path: "terms-and-conditions",
        loadComponent: () => import('./terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
      },
      {
        path: "unauthorized",
        loadComponent: () => import('./unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
      },
      {
        path: "forbidden",
        loadComponent: () => import('./forbidden/forbidden.component').then(m => m.ForbiddenComponent)
      },
      {
        path: "server-not-found",
        loadComponent: () => import('./server-not-found/server-not-found.component').then(m => m.ServerNotFoundComponent)
      },
      {
        path: "internal-server-error",
        loadComponent: () => import('./internal-serve-error/internal-serve-error.component').then(m => m.InternalServeErrorComponent)
      },
      {
        path: "connection-refused",
        loadComponent: () => import('./connection-refused/connection-refused.component').then(m => m.ConnectionRefusedComponent)
      },
      { path: "**", redirectTo: "/"}
    ],
  }

];

